// extracted by mini-css-extract-plugin
export var externalLink = "_a3-0";
export var internalLinkLabel = "_a3-1";